/**
 * Defines an interface intended to be implemented by all layout containers that include mechanisms for
 * hiding their children from view.  The purpose of this mixin is to provide a means for determining whether a child
 * is visible, not only within its immediate parent but within all ancestor containers.
 *
 * @module MW/layout/HidingContainer
 * @copyright Copyright 2016 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {
    var HidingContainer =  declare([], {

        /**
         * Returns true if the specified child is being shown by its immediate parent.
         *
         * The default implementation returns true for any children in the container.  Implementing containers should
         * override this method to return false for their hidden children.
         *
         * @param child {_Widget}
         * @instance
         */
        isShowingLocally: function (child) {
            return child.getParent() === this;
        }
    });

    /**
     * Returns true if the given child and any ancestors residing within HidingContainers are all showing
     * within their respective parent containers.
     */
    HidingContainer.isShowingGlobally = function (child) {
        var parent = child.getParent();
        while (parent) {
            if (parent.isInstanceOf(HidingContainer) && !parent.isShowingLocally(child)) {
                return false;
            }
            child = parent;
            parent = child.getParent();
        }
        return true;
    };

    return HidingContainer;
});